import { Controller } from "@hotwired/stimulus"

// Lightweight reactive label for the admin AppSettings boolean toggle.
// Track + status-label color are driven entirely by CSS :has(:checked)
// (gl-toggle--switch / .gl-toggle-status-group in _status-components.scss);
// this controller flips the label text between Enabled / Disabled on the
// checkbox's change event so the visual fully matches the value about to be
// submitted (color alone is not enough — a "Disabled" label in green is
// semantically contradictory).
//
// Usage (see app/views/admin/app_settings/_form.html.haml):
//   div[data-controller="app-setting-toggle"]
//     input[type="checkbox" data-action="change->app-setting-toggle#flip"]
//     label[data-app-setting-toggle-target="label"]
//       Enabled
export default class extends Controller {
  static targets = ["label"]

  flip(event) {
    this.labelTarget.textContent = event.target.checked ? "Enabled" : "Disabled"
  }
}
